module.exports = __webpack_public_path__ + "img/galactic-senate.94bfe08f.svg";